export const getDefaultState = () => {
  return {
    event: {}
  }
}
